<template>
  <div>
    <headerNav title="差价查询" />
    <div class="cheader" v-if="userInfo">
          <div class="cmoneys" :style="{color:$abctheme.basecolor}">
              <div class="cmoney-wz">
                  销售返利总金额
              </div>
              <div class="cmoney-money">
                  <div><span>￥</span>{{userInfo.spread||"0.00"}}</div>
              </div>
          </div>
    </div>
    <div>
         <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                      v-model="navitem.loaded"
                      :finished="navitem.loadingType=='nomore'?true:false"
                      :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                      @load="loadData"
                  >
                    <div v-for="(item,index) in navitem.list" class="mian-list" :key="index">
                          <div class="mian-list-info">
                             <div class="mian-list-info-data">
                              <span>订单号:</span>
                              <span>{{item.rechargeRecordTid}}</span>
                            </div>
                            <div class="mian-list-info-data">
                              <span>返利:</span>
                              <span>{{item.money}}</span>
                            </div>
                            <div class="mian-list-info-data">
                              <span>下级充值代理:</span>
                              <span>{{item.fromDealerName}}</span>
                            </div>
                            <div class="mian-list-info-data">
                              <span>充值金额:</span>
                              <span>{{item.rechargeMoney}}</span>
                            </div>
                            <div class="mian-list-info-data">
                              <span>划拨金额:</span>
                              <span>{{item.transferBalance}}</span>
                              <!-- <van-tag type="success" class="mian-list-info-right-tag" v-if="item.isAudit==1" size="medium">{{item.balanceProductTypeName}}}</van-tag> -->
                            </div>
                          </div>
                    </div>
                </van-list>
          </van-pull-refresh>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      date: "",
      show: false,
      tabCurrentIndex:0,
      navitem:{
          state: 0,
          text: '全部',
          loadingType: 'more',
          loaded:false,
          getparams: {
              "sorting": "",
              "maxResultCount": 10,
              "skipCount": 0
          },
          list: [ ]
      },
      loading: false,
      finished: false,
      refreshing: false,
      userInfo:undefined
    };
  },
  created(){
    this.queruserinfo();
  },
  methods: {
    tabchange()
    {
        this.loadData('tabChange');
    },
    onRefresh()
    {
        this.loadData('refresh');
    },
    queruserinfo()
    {
      this.ajax.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
        this.userInfo = x.result;
        this.abp.userInfo = x.result;
      });
    },
    loadData(source) {
        let navItem = this.navitem;
        // let state = navItem.state;
        
        if (source === 'tabChange' && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
            //防止重复加载
            if(source!="refresh")
            {
                return;
            }
            
        }
        if (source === 'refresh') {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = 'loading';
        var params = navItem.getparams;
        //加载数据
        this.ajax.post('/api/services/app/PhoneWallet/QueryMySpreadRecords', params).then(x => {
        this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
        let totalcount = x.result.totalCount;
        this.navitem.list = this.navitem.list.concat(x.result.items);
        //console.log(this.navList);
        // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType = totalcount > (this.navitem.getparams.skipCount) ? 'more' :'nomore';
        }).finally(()=>
        {
            this.$set(this.navitem, 'loaded', false);
            this.refreshing=false;
        });
    }
    
  },
};
</script>
<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  padding-bottom: 20px;
}
.mian-list-info{
  padding: 5px 0;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.mian-list-info-data{
   min-height: 30px;
   padding-right: 90px;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag{
  position: absolute;
  right: 0;
}
.mian-list-mark{
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}

.cheader{
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    border-bottom:1px solid #e6e6e6;
}
.cmoneys
{
    display: inline-block;
    width: 32%;
    font-size: 14px;
    color:#c6bcf8;
}
.cmoney-money
{
    font-size: 25px;
}
.cbtns{
    font-size: 20px;
}
.cbtns button
{
    background-color: #c6bcf8;
    color:white;
    border: 0;
    padding: 2px 30px;
    border-radius: 10px;
    box-shadow: 1px 1px 4px #e6e6e6;
}
</style>